import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { find } from 'lodash';
import { combineLatest, Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { CategoriesStorage, Category } from '../documents';
import { GeneralDocumentsComponentBase } from './base/general-documents-component-base';
import { GeneralReportsStorage } from './general-reports-storage';
import { routeParams } from '../shared/route-helpers';

@Component({
    selector: 'general-documents-with-categories',
    template: require('./general-documents-with-categories.component.html'),
    styles: [require('./base/general-documents.component-base.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralDocumentsWithCategoriesComponent extends GeneralDocumentsComponentBase {
    constructor(
        protected route: ActivatedRoute,
        private categoriesStorage: CategoriesStorage,
        public reportsStorage: GeneralReportsStorage
    ) {
        super(reportsStorage);
    }

    protected createSelectedCategory(): Observable<Category> {
        const categoryId = this.route.parent.params.pipe(map(x => x[routeParams.categoryId] as string | undefined));
        const childCategoryId = this.route.params.pipe(map(x => x[routeParams.childCategoryId] as string | undefined));

        const childCategory = combineLatest(
            categoryId,
            childCategoryId,
            this.categoriesStorage.generalCategories
        )
            .pipe(
                map(([categoryIdValue, childCategoryIdValue, generalCategories]) => {
                    const category = find(generalCategories, c => c.categoryId === categoryIdValue);

                    if (!category) {
                        return null;
                    }

                    return find(category.children, c => c.categoryId === childCategoryIdValue);
                }),
                publishReplay(1),
                refCount()
            );

        return childCategory;
    }
}